import { TargetType } from '../../../../components/Filter/@types';

export type APIFilterParams = {
  carPlate?: string;
};

export interface FiltersState {
  isPanelOpen: boolean;
  target: string | null;
  targetType: TargetType | null;
  VEHICLE: any | null;
  AREA: any;
  CLAIM: any;
  CARE: any;
  SHARE: any;
  BOOKING: any;
  CATEGORIES: any;
  PRICING: any;
  PRIVACY_POLICY: any;
  PROFILE: any;
  USERS: any;
  ADMINS: any;
  RECEIPTS: any;
  FUEL_TRANSACTIONS: any;
  CIRCLE: any;
  REPORTS: any;
}

export const initialState = {
  isPanelOpen: false,
  target: null,
  targetType: null,
  VEHICLE: {},
  AREA: {},
  CLAIM: {},
  CARE: {},
  SHARE: {},
  BOOKING: {},
  CATEGORIES: {},
  PRICING: {},
  PRIVACY_POLICY: {},
  PROFILE: {},
  USERS: {},
  ADMINS: {},
  RECEIPTS: {},
  FUEL_TRANSACTIONS: {},
  CIRCLE: {},
  REPORTS: {},
};
